module.exports = __webpack_public_path__ + "static/media/20.25195a83.jpg";